import { FC, HTMLAttributes } from "react";
import { useStyles } from "./ResultScreen.style";
import CountdownButton from "../../common/CountdownButton/CountdownButton";
import GameSuggestionCard from "../../common/GameSuggestionCard/GameSuggestionCard";
import NoRewardView from "../../common/NoRewardView/NoRewardView";
import RewardView from "../../common/RewardView/RewardView";
import { RankGemTag } from "../../common/RankGemTag/RankGemTag";

interface IRankCardProps {
  reward: number;
  onCloseEndscreen: () => void;
}

export const ResultScreen: FC<
  IRankCardProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { reward, onCloseEndscreen, ...otherProps } = props;
  const classes = useStyles();

  return (
    <div className={classes.resultScreen} {...otherProps}>
      <div className={classes.rank}>
        <RankGemTag className={classes.lbRank} isResult isWin={reward > 0} />
      </div>
      {reward ? <RewardView gems={reward} /> : <NoRewardView />}
      <div className={classes.content}>
        <GameSuggestionCard onCloseEndscreen={onCloseEndscreen} />
        <CountdownButton />
      </div>
    </div>
  );
};

export default ResultScreen;
